const COOKIE_IDS = Object.freeze({
  CONSENT: `consent`,
  ANNOUNCEMENT: `announcement`,
})

export default COOKIE_IDS
